import { Location } from '@cobliteam/common-types';
import { GeofencesDef, GeofenceType } from '@cobliteam/common-types/src/geofenceV3';
import { useGetGeofenceById } from '@cobliteam/hooks/src/useEntity/useGeofenceV3';
import { useTranslation } from '@cobliteam/i18n';
import GeofenceTag from '@cobliteam/ui-business/components/Tag/Geofences/Geofences';
import { useFleetCategories } from '../../../globalSidebarDef';
import { getCategory } from '../../../helpers';
import { useSearch } from '../../../hooks/useSearch';
import { EnumCategory, type GeofenceWithCategory } from '../../../types';
import CardHeader from '../../Cards/CardHeader';
import CardMapGeojson from '../../Cards/CardMapGeojson';
import GeofenceDetailsSkeleton from './GeofenceDetailsSkeleton';
import GeofenceIcon from './GeofenceIcon';

const GeofenceDetails = () => {
  const { t } = useTranslation('global-search');
  const { selectedItem } = useSearch();
  const { data: geofence, isLoading: isLoadingGeofence } = useGetGeofenceById(selectedItem?.id || '');
  const fleetCategories = useFleetCategories(t);

  if (!selectedItem) return null;
  if (isLoadingGeofence) return <GeofenceDetailsSkeleton />;
  const item = selectedItem as GeofenceWithCategory;
  const category = getCategory(EnumCategory.GEOFENCES, fleetCategories);

  if (!category) return null;

  const title = geofence?.name || '---';
  const subtitle = geofence?.type !== 'PATH' ? geofence?.address || 'Endereço não disponível' : '---';
  const area = item?.area ? `${item.area.toFixed(2)}m²` : '---';

  // Get coordinates from geojson or centerLatLong
  const latitude = geofence?.geometryPoint?.coordinates?.[1] || geofence?.geometryPolygon?.coordinates?.[0]?.[0]?.[1];
  const longitude = geofence?.geometryPoint?.coordinates?.[0] || geofence?.geometryPolygon?.coordinates?.[0]?.[0]?.[0];

  return (
    <div className='relative flex h-[500px] w-full flex-col gap-4 overflow-hidden overflow-y-auto p-4'>
      <CardHeader
        icon={item.category.icon}
        color={item.category.color}
        title={title}
        subtitle={subtitle}
        linkTooltip={t('geofence_details.view_place_of_interest')}
        link={`${Location.MONITORING}?tab=geofences&search=${geofence?.name}`}
      />

      {/*Details*/}
      <div className='grid grid-cols-12 gap-2'>
        <div className='col-span-6'>
          <div className='mb-1 flex items-center gap-2 font-medium text-xs'>{t('geofence_details.information')}</div>
          <div className='w-full'>
            <div className='text-xs'>
              {t('geofence_details.area')} {area}
            </div>
          </div>
        </div>

        <div className='col-span-6 flex items-center justify-end'>
          <GeofenceTag variant='surface' geofenceType={geofence?.type || GeofenceType.DEFAULT} />
        </div>
      </div>

      <CardMapGeojson
        title={t('card_map.vehicle_location_title')}
        id={geofence?.id}
        latitude={latitude}
        longitude={longitude}
        color={GeofencesDef[geofence?.type || GeofenceType.DEFAULT].color}
        icon={GeofenceIcon(geofence?.type as GeofenceType)}
        type={geofence?.type as GeofenceType}
        geojson={geofence?.geometryPolygon}
        updatedAt={geofence?.updatedAt ? new Date(geofence.updatedAt).getTime() : null}
        linkTo={`/monitoring?tab=geofences&geofenceId=${geofence?.id}`}
      />
    </div>
  );
};

export default GeofenceDetails;
